import { render } from "./AppMain.vue?vue&type=template&id=d67541dc&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=js"
export * from "./AppMain.vue?vue&type=script&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=d67541dc&scoped=true&lang=css"

import exportComponent from "F:\\repos\\ideahonlapom\\gombavezetes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67541dc"]])

export default __exports__